import React from "react";
import styles from "./skeleton.css";

const Skeleton = () => {
    return <div className="shimmer" styleName="styles.card"/>;
};

export default Skeleton;
